import SimpleAccordion from '../../../Core/Expansion/SimpleAccordion'
import React, { useState,useContext } from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { ReactComponent as AICircle } from '../../../../assets/ai.svg';
import { ReactComponent as PersonCircle } from '../../../../assets/person_with_circle.svg';
import { Dialog } from '@material-ui/core';
import CircledPopUpFrame from '../../../Core/CircledPopUpFrame';
import { isMobile } from 'react-device-detect';
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService';
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog';
import { useLocation } from 'react-router-dom';
import DataLayerService from '../../../../services/DataLayerService';
import {LiabilityExtensionManage,LiabilitySection} from '../PolicyDetailSections/LiabilitySection'
import PolicyLiabilityExtensionContext, { PolicyLiabilityExtensionContextStore, ACTIONS } from '../../../../context/PolicyLiabilityExtensionContext'
import {POLICY_MODIFICATION_CONTEXT_ACTIONS, ModificationContextStore} from '../../../../context/ModificationContext'
import { billingPeriodPretty, liabilityLimitPretty,AddComa } from '../../../../services/utils'
import { LiabilityCoveragePopover } from '../../../Core/Popover/LiabilityCoveragePopover'
import ViolationsService from '../../../../services/ViolationsService'
import { Action } from '../../../../models/Action';
import { NOT_COVERED_PER_PASS_LIABILITY_ID,BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY } from '../../../../Constants'
import {
    SectionSelect,
    SectionSlider,
    SectionSpecialSelect,
    SectionTria,
} from '../../../Core/Form/FormComponents'
import { BuyingInsuranceContextStore } from '../../../../context/BuyingInsuranceContext'
import { SessionContextStore } from '../../../../context/SessionContext'
import { SessionService } from '../../../../services/SessionService'
import { SkyInformationPopover } from '../../../Core/Popover/SkyPopover'

interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}


export const ModifyLiabilityDamageCoverage = ({...props}) => {
    const modificationContext = React.useContext(ModificationContextStore) 
    const offersContext = useContext(BuyingInsuranceContextStore)
    const sessionContext = React.useContext(SessionContextStore)
    const [isOpen,setIsOpen] = React.useState(false)
    const [error, setError] = React.useState()
    const {insurance, modificationObject, isRenewal,modify} = props;
    const [isLiabilityInvalid, setIsLiabilityInvalid] = React.useState(false)
    const [aircraftDamageLiabilityOptions,setAircraftDamageLiabilityOptions] = React.useState(modificationContext.liabilityLimitOptions)
    
    const [initialAircraftDamageValue, setInitialAircraftDamageValue] =
        React.useState(
            modificationObject.offer.liability.liability
        )
    

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS);

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS, id)
        }
    }, [])

    React.useEffect(() => {
        const calcOptionsAircraftDamageLiability = async () => {
            let options = modificationContext.liabilityLimitOptions
            setInitialAircraftDamageValue(
                modificationObject.offer.liability.liability
            )
            const value = modificationObject.offer.liability.liability.replace(/[:, ]/g, '')
            if(modificationObject.billingPeriod != 'Annual' && !BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY.includes(value)){
                options = options.filter(x=>!BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY.includes(x.label))
            }
            if(sessionContext.user.userInsuredPersons[0]?.pilot_certification.toLowerCase() === "student" && insurance.insurancePeriodDescription === 'Annual'){
                const index = options.findIndex(obj => obj.label === "$100000")
                options = index !== -1 ? options.slice(0, index + 1) : options
            }
            var index =
                modificationContext.liabilityLimitOptions.findIndex(
                    (obj) =>
                        obj.value ===
                        modificationObject.selectedLiability.liability
                )
            if(!SessionService.isAdmin()){
                options = options.slice(index)
            }
            
            const updatedArray = options.map(item => ({
                ...item,
                label: item.label.replace(/,/g, '') 
            }));

            const selectedLiabilityExists = options.some(
                option => option.value === modificationObject.selectedLiability.liability
            );
            setIsLiabilityInvalid(!selectedLiabilityExists);
            setAircraftDamageLiabilityOptions(updatedArray)
        }
        calcOptionsAircraftDamageLiability()
    }, [])

    const onPolicyFieldChange = (name,value) => {
        
        //if(modify){
        const option = aircraftDamageLiabilityOptions.find(l => l.value == value)
        modificationContext.setLiabilityLimit(value,isRenewal)
        
    }

    const getCoverageTooltip = (coverageName) => {
        if (coverageName == 'tria') {
            return 'Affords insurance in compliance with and to the extend required by the provisions of the federal Terrorism Rick Insurance Act of 2002, as amended.'
        } else if (coverageName == 'aircraft_damage_liability') {
            return "The Physical Damage to Non-Owned Aircraft coverage includes 'Loss of Use' of a non-owned aircraft, for which you are legally liable. The 'Loss of Use' limit of liability is included within the 'Damage Limit'. You must select a Damage Limit or decline this coverage to continue."
        }
        let value = offersContext.options[coverageName]
        return value && value.length > 1 ? value[0].tooltip : undefined
    }

    return (
        <React.Fragment>
           <SimpleAccordion onClick={()=>setIsOpen(!isOpen)} isOpen={isOpen} className='margin-top-large'
           title={
           <FlexView column className="space-between full-width"> 
                <div>Liability Insurance for damage to non-owned aircraft <SkyInformationPopover><div className="text-small">
                    The Physical Damage to Non-Owned Aircraft coverage includes 'Loss of Use' of a non-owned aircraft, for which you are legally liable. The 'Loss of Use' limit of liability is included within the 'Damage Limit.' You must select a Damage Limit or decline this coverage to continue.
                </div></SkyInformationPopover></div>
                <div className="grey text-small">
                    {modificationObject.offer.liability.liability} Liability limit/ Premium ${modificationObject.offer.liability.price}
                </div>
           </FlexView>} 
                content={
                    <PolicyLiabilityExtensionContext>
                    <FlexView column>
                    {isLiabilityInvalid && !SessionService.isAdmin() && (
                        <div  style={{ color: 'red', textAlign: 'left', marginLeft: '-1em' }}>
                        At this time, your current Aircraft Liability limit cannot be changed.
                        <br />
                        For more information, feel free to reach out to our support team at aviationsupport@skywatch.ai. 
                        </div>
                    )}
                    {isLiabilityInvalid && SessionService.isAdmin() &&(
                        <div  style={{ color: 'red', textAlign: 'left', marginLeft: '-1em' }}>
                        Coverage options for this renewal are limited based on age eligibility requirements.
                        </div>
                    )}
                    {(!isLiabilityInvalid || SessionService.isAdmin()) && (
                        isMobile ? (
                            <SectionSelect
                                name="aircraft_damage_liability"
                                value={modificationObject.selectedLiability.liability}
                                buttons={aircraftDamageLiabilityOptions}
                                tooltip={getCoverageTooltip('aircraft_damage_liability')}
                                subtitle="Insurance coverage that applies to damage that you are legally liable to pay as a result of damage to non-owned aircraft that is in your care."
                            />
                        ) : (
                            <SectionSlider
                                name="aircraft_damage_liability"
                                subtitle={
                                    'Insurance coverage that applies to damage that you are legally liable to pay as a result of damage to non-owned aircraft that is in your care.'
                                }
                                value={modificationObject.selectedLiability.liability}
                                options={aircraftDamageLiabilityOptions}
                                tooltip={getCoverageTooltip('aircraft_damage_liability')}
                    onChange={(name, value) => {
                        onPolicyFieldChange(
                            name,
                            aircraftDamageLiabilityOptions.find(
                                (opt) => Number(opt.label.replace(',', '').slice(1)) == value
                            ).value
                        )
                    }}
                                marks={aircraftDamageLiabilityOptions.map((opt, index) => {
                                    if (
                            index ==
                                aircraftDamageLiabilityOptions.length - 1 ||
                                        index == 0 ||
                            index ==
                                Math.round(
                                    aircraftDamageLiabilityOptions.length / 2
                                )
                                    )
                                        return {
                                            value: Number(opt.label.replace(',', '').slice(1)),
                                            label: '$' + AddComa(opt.label.replace(',', '').slice(1)),
                                        }
                                    else
                                        return {
                                            value: Number(opt.label.replace(',', '').slice(1)),
                                        }
                                })}
                    min={Number(
                        aircraftDamageLiabilityOptions[0].label.slice(1)
                    )}
                    max={Number(
                        aircraftDamageLiabilityOptions[
                            aircraftDamageLiabilityOptions.length - 1
                        ].label.slice(1)
                    )}
                            />
                    ))}
                    {!!error && error}</FlexView>
                    </PolicyLiabilityExtensionContext>
                    }/>
        </React.Fragment>)
    }